import { Component, OnInit } from '@angular/core';
import { MasterService } from 'src/app/services/master/master.service';
import { AlertService } from 'src/app/_services/alert.service';
import { ImportFilesDialogService } from 'src/app/_utils/import-files-dialog/import-files-dialog.service';
//import { AlertService } from '../_services/alert.service';
import { BaseComponent } from '../../base.component';
@Component({
  selector: 'app-professionmaster',
  templateUrl: './professionmaster.component.html',
  styleUrls: ['./professionmaster.component.css']
})
export class ProfessionmasterComponent extends BaseComponent implements OnInit {
  cp = 1;
  ord = true;
  colname: "Name";
  text;
  today: number = Date.now();
  public professionObj: any = [];
  constructor(
    private master: MasterService,
    private alertService: AlertService,
    private ImportFilesDialogService: ImportFilesDialogService,

  ) {
    super();
   }

  ngOnInit() {
    this.getProfessionData();
    this.ProfessionLogData()
  }
  ProfessionLogData() {
    let ProfessionLogs = {
      log_type:"Profession Master View" ,
      log_name:"Profession Master View" ,
      log_description:"Profession Master View" ,
      moduleid:1 ,
      moduleitemid:7,
      per_id:14
    }
    this.logs.addNewLogs(ProfessionLogs).subscribe(data => {
     // console.log(data);

    }, error => {
     // console.log(error);
    });

}
  chgord(col) {
    this.ord = !this.ord
    this.colname = col
  }
  getProfessionData() {
    let self = this;
    this.ngxSpinnerService.show();
    this.master.getProfession().subscribe(data => {
      self.professionObj = data;
      this.ngxSpinnerService.hide();
    }, error => {
    //  console.log(error);
      this.ngxSpinnerService.hide();
    });
  }

  deleteProfession(id) {
    let obj = {
      id: id
    }
    this.confirmationDialogService.confirm('PLEASE CONFIRM', 'Are you sure you want to Delete?', 'Ok', 'Cancel')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.master.delProfession(obj).subscribe(data => {
            if (data.status) {
              this.getProfessionData();
              setTimeout(() => {
                this.toastrService.success("Deleted Successfully");
              }, 1000)
            } else {
              this.alertService.error(data.message)
            }
            this.ngxSpinnerService.hide();
          }, error => {
           // console.log(error);
            this.ngxSpinnerService.hide();
          });
        }
      }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }
  editProfession(id) {
    this.router.navigate(['/corporate/addnewprofession'], { queryParams: { prosfession_id: id } });
  }
  updateStatus(event, id) {
    event.preventDefault();
    let obj = this.professionObj.find(element => {
      //console.log(element.get_master_company_type.company_type_id)
      if (element.get_master_profession.proid === id) {
        return true;
      }
    });
    obj = obj.get_master_profession;
    this.confirmationDialogService.confirm('PLEASE CONFIRM', 'Are you sure you want to change the status?', 'YES', 'NO')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          obj.isactive = !obj.isactive;
          this.master.updateProfession(obj).subscribe(data => {
            if (data.status){
              this.toastrService.success("Status Changed Successfully");
              this.getProfessionData();
              this.ngxSpinnerService.hide();
            } else {
              this.toastrService.error(data.message);
              this.ngxSpinnerService.hide();
            }

          }, error => {
            this.toastrService.error('An error Occured');
            this.ngxSpinnerService.hide();
          });

        }

        // else {
        //   this.master.updateProfession(obj).subscribe(data => {
        //     // console.log(data)

        //     setTimeout(() => {
        //       this.toastrService.success("Status Changed Successfully");
        //     }, 1000)
        //     this.getProfessionData();
        //   });
        // }
      }).catch(() => {
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      });
  }
  setValue(event) {
    let self = this;
    let url = event.target.src;
    if (url.indexOf("master_images") > 0) {
      url = url.substring(url.indexOf("master_images"), url.length)
      if (!this.isUrlValid(url)) {
        let awsUrl = self.master.getUrlfile(url);
        event.target.src = self.isUrlValid(awsUrl) ? awsUrl : '../../../assets/custom/images/broken.png';
      } else {
        event.target.src = '../../../assets/custom/images/broken.png';
      }
    } else {
      event.target.src = '../../../assets/custom/images/broken.png';
    }
    event.target.onerror = null;
  }
  isUrlValid(userInput) {
    return /(https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/i.test(userInput);
  }
  importFile() {
    let self = this;
    self.ImportFilesDialogService.confirm('Please Choose the File Path ', `../../../assets/margo-import-files/margo-profession-import.csv`, 'addingProfessionBulk')
      .then(data => {
      //  console.log(data);
        self.getProfessionData();
      })
      .catch(err => {
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      })
  }
  exportFile() {
    let tablename = {
      "tableName": "master_profession"
    }
    this.master.exportBulk(tablename).subscribe(dataFile => {
      if (dataFile.status) {
        let selBox = document.createElement('a');
        var att = document.createAttribute("href");
        att.value = dataFile.file;
        var att1 = document.createAttribute("download");
        selBox.setAttributeNode(att);
        selBox.setAttributeNode(att1);
        document.body.appendChild(selBox);
        selBox.click();
      }
    }, err => {
      this.toastrService.error(err.message);
    });
  }
}
